<template>
    <div v-if="last_page > 1" class="py-2">
        <nav class="d-flex justify-content-center">
            <paginate
                :page-count="last_page"
                :click-handler="goto"
                prev-text="前"
                next-text="次"
                :modelValue="modelValue"
                @update:modelValue="$emit('update:modelValue', $event)"
                container-class="pagination"
                page-class="page-item"
                prev-class="page-item"
                next-class="page-item"
                page-link-class="page-link"
                prev-link-class="page-link"
                next-link-class="page-link"
            ></paginate>
        </nav>
    </div>
</template>

<style>
.page-link {
    cursor: pointer;
}
</style>

<script>
export default {
    props: {
        last_page: {
            required: true,
        },
        initial_page: {
            default: 1
        },
        modelValue: {
            default: 1
        }
    },
    methods: {
        goto(p) {
            this.$emit("goto", p);
        }
    }
}
</script>